import Api from "shared/service/api/api";

//actions
export const LOAD_USERS = "loadUsers";
export const LOAD_CONSULTATIONS = "loadConsultations";

//mutations
export const SET_USERS = "setUsers";
export const SET_CONSULTATIONS = "setConsultations";

const state = {
  users: {
    list: [],
    page: 1,
    page_count: 1,
  },
  consultations: {
    list: [],
    page: 1,
    page_count: 1,
  }
};

const actions = {
  [LOAD_USERS]({ commit }, { page, user_id = null }) {
    Api.admin.user
      .all(page, user_id)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_USERS, response.data);
      })
      .catch((e) => e);
  },
  [LOAD_CONSULTATIONS]({ commit }, { page }) {
    Api.admin.consultation
      .all(page)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_CONSULTATIONS, response.data);
      })
      .catch((e) => e);
  },
};

const mutations = {
  [SET_USERS](state, { list, page, page_count }) {
    state.users.list = list.map((user) => {
      user.full_name = user.first_name + " " + (user.last_name || "");
      return user;
    });
    state.users.page = page;
    state.users.page_count = page_count;
  },
  [SET_CONSULTATIONS](state, { list, page, page_count }) {
    state.consultations.list = list;
    state.consultations.page = page;
    state.consultations.page_count = page_count;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
